<form [formGroup]="form" autocomplete="off">
  <div class="title-container">
    <emr-input type="text" [control]="titleFormControl" placeholder="Note Title *"></emr-input>
  </div>
  <div class="content-container">
    <div class="editor-container">
      <p-editor [formControl]="noteFormControl" [style]="{ height: '10rem' }" placeholder="Enter note here"></p-editor>
    </div>
    <div class="sign-note-container">
      <p-datepicker class="input-field calendar-field" [formControl]="dateFormControl" [showTime]="true" hourFormat="24"
        placeholder="Date/Time *" [showIcon]="true" appendTo="body">
      </p-datepicker>
      <emr-input type="text" [control]="signatureFormControl" placeholder="Signature *" />
    </div>
  </div>
</form>